export const messages = {
  en: {
    businessTableHisManage: {
      queryCondition: 'Query Conditions',
      selectAction: 'Please select action',
      inputTableName: 'Please input table name',
      inputBusinessType: 'Please input business type',
      query: 'Query',
      reset: 'Reset',
      businessTrack: 'Business Track',
      add: 'Add',
      trackId: 'Track ID',
      businessType: 'Business Type',
      action: 'Action',
      tableName: 'Table Name',
      trackTableName: 'Track Table Name',
      operation: 'Operation',
      modify: 'Modify',
      delete: 'Delete',
      pleaseSelect: 'Please select'
    },
    addBusinessTableHis: {
      addBusinessTrack: 'Add Business Track',
      businessType: 'Business Type',
      requiredBusinessType: 'Required, please input business type',
      action: 'Action',
      requiredAction: 'Required, please select action',
      tableName: 'Table Name',
      requiredTableName: 'Required, please input table name',
      trackTableName: 'Track Table Name',
      requiredTrackTableName: 'Required, please input track table name',
      remark: 'Remark',
      optionalRemark: 'Optional, please input remark',
      save: 'Save',
      cancel: 'Cancel',
      addSuccess: 'Add success',
      max30Chars: 'Maximum 30 characters',
      max64Chars: 'Maximum 64 characters',
      max200Chars: 'Maximum 200 characters',
      pleaseSelect: 'Please select'
    },
    editBusinessTableHis: {
      editBusinessTrack: 'Edit Business Track',
      businessType: 'Business Type',
      requiredBusinessType: 'Required, please input business type',
      action: 'Action',
      requiredAction: 'Required, please select action',
      tableName: 'Table Name',
      requiredTableName: 'Required, please input table name',
      trackTableName: 'Track Table Name',
      requiredTrackTableName: 'Required, please input track table name',
      remark: 'Remark',
      optionalRemark: 'Optional, please input remark',
      save: 'Save',
      cancel: 'Cancel',
      editSuccess: 'Edit success',
      requiredTrackId: 'Track ID is required',
      max30Chars: 'Maximum 30 characters',
      max64Chars: 'Maximum 64 characters',
      max200Chars: 'Maximum 200 characters',
      pleaseSelect: 'Please select'
    },
    deleteBusinessTableHis: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteTrack: 'Confirm to delete business track?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete success',
      clickWrong: 'Clicked wrong'
    }
  },
  zh: {
    businessTableHisManage: {
      queryCondition: '查询条件',
      selectAction: '请选择动作',
      inputTableName: '请输入表名',
      inputBusinessType: '请输入业务类型',
      query: '查询',
      reset: '重置',
      businessTrack: '业务轨迹',
      add: '添加',
      trackId: '轨迹ID',
      businessType: '业务类型',
      action: '动作',
      tableName: '表名',
      trackTableName: '轨迹表名',
      operation: '操作',
      modify: '修改',
      delete: '删除',
      pleaseSelect: '请选择'
    },
    addBusinessTableHis: {
      addBusinessTrack: '添加业务轨迹',
      businessType: '业务类型',
      requiredBusinessType: '必填，请填写业务类型',
      action: '动作',
      requiredAction: '必填，请选择动作',
      tableName: '表名',
      requiredTableName: '必填，请填写表名',
      trackTableName: '轨迹表名',
      requiredTrackTableName: '必填，请填写轨迹表名',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      save: '保存',
      cancel: '取消',
      addSuccess: '添加成功',
      max30Chars: '最多30个字符',
      max64Chars: '最多64个字符',
      max200Chars: '最多200个字符',
      pleaseSelect: '请选择'
    },
    editBusinessTableHis: {
      editBusinessTrack: '修改业务轨迹',
      businessType: '业务类型',
      requiredBusinessType: '必填，请填写业务类型',
      action: '动作',
      requiredAction: '必填，请选择动作',
      tableName: '表名',
      requiredTableName: '必填，请填写表名',
      trackTableName: '轨迹表名',
      requiredTrackTableName: '必填，请填写轨迹表名',
      remark: '备注',
      optionalRemark: '选填，请填写备注',
      save: '保存',
      cancel: '取消',
      editSuccess: '修改成功',
      requiredTrackId: '轨迹ID不能为空',
      max30Chars: '最多30个字符',
      max64Chars: '最多64个字符',
      max200Chars: '最多200个字符',
      pleaseSelect: '请选择'
    },
    deleteBusinessTableHis: {
      confirmOperation: '请确认您的操作',
      confirmDeleteTrack: '确定删除业务轨迹?',
      cancel: '取消',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      clickWrong: '点错了'
    }
  }
}